export default __webpack_public_path__ + "static/media/ChinweNvene.fbcce73c.jpg";